uniform vec4 uColorA;
uniform vec4 uColorB;
uniform float uSpacing;
uniform float uWidth;
uniform float uTime;
uniform float uSpeed;
uniform float uSharpness;
uniform float uBlend;
uniform vec3  uEmissiveA;
uniform float uEmissiveIntensityA;
uniform vec3  uEmissiveB;
uniform float uEmissiveIntensityB;

varying vec2 vUv;

void main() {
  float t1   = fract((vUv.x - uTime * uSpeed) / uSpacing);
  float seg1 = pow(sin(t1 * 3.14159), uSharpness);

  float t2   = fract((vUv.x + uTime * uSpeed) / uSpacing);
  float seg2 = pow(sin(t2 * 3.14159), uSharpness);

  float segment  = mix(seg1, seg2, uBlend);
  vec4  baseColor = mix(uColorA, uColorB, segment);

  // blend the emissive colors first, then mask by the combined segment
  vec3 emissiveColor = mix(
  uEmissiveA * uEmissiveIntensityA,
  uEmissiveB * uEmissiveIntensityB,
  uBlend
  );
  vec3 emissive = emissiveColor * segment;


  gl_FragColor = vec4(baseColor.rgb + emissive, baseColor.a);
}